import { AutogenModelScreenCodes, AutogenRowScreenCodes } from "./autogen/AutogenModelScreenCodes";

export class ModelScreenCodes extends AutogenModelScreenCodes<RowScreenCodes> {
	constructor() {
		super(RowScreenCodes);
	}
}

export class RowScreenCodes extends AutogenRowScreenCodes {
}